import React, { Component } from "react";

import Hidden from "material-ui/Hidden";
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "material-ui/Table";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Collapse from "material-ui/transitions/Collapse";
import Typography from "material-ui/Typography";

import RelatedNav from "./RelatedNav";

class ServiceListItem extends Component {
  state = {
    collapsed: false
  };

  render() {
    const { service, selectService, selectedService } = this.props;
    return (
      <Grid item xs={12} className="serviceList">
        <Paper>
          <Collapse
            in={this.state.collapsed || service === selectedService}
            onClick={(e, selectedService, service) => this.handleClick(e)}
            collapsedHeight="57px"
          >
            <Table onClick={e => {
                e.persist();
                selectService(service.id);
                let event = e;
                const cb = event => {
                  this.props.mobileSize &&
                    event.target.scrollIntoView({ behavior: "smooth" });
                };
                setTimeout(cb.bind(null, event), 1000);
              }}>
              <TableHead
                className={
                  service === selectedService
                    ? "active"
                    : this.props.mobileSize && this.state.collapsed
                    ? "active"
                    : ""
                }
              >
                <TableRow>
                  <TableCell>
                    <Typography variant="body2">{service.name}</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <Hidden mdUp>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <Typography variant="body2" align="justify">
                        {service.description}
                        {selectedService !== null &&
                        (selectedService.doktori || selectedService.aparati) ? (
                          <RelatedNav service={selectedService} />
                        ) : (
                          ""
                        )}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Hidden>
            </Table>
          </Collapse>
        </Paper>
      </Grid>
    );
  }

  handleClick = (e, selectedService, service) => {
    if (selectedService === service && this.state.collapsed === false) {
      this.setState({ collapsed: false });
      return;
    }
    this.setState({ collapsed: !this.state.collapsed });
  };
}

export default ServiceListItem;



// WEBPACK FOOTER //
// ./src/components/ServiceListItem.js